import * as React from 'react';
import styled from 'styled-components';
import { useHookSubscribe } from '../../../../react-rxjs';
import { useMapDimension } from '../../../hooks/useMapDimension';
import { useMapStore } from '../../../hooks/useMapStore';
import { useMapCountryDimension } from '../../../hooks/useMapCountryDimension';
import { MapDataSourceId } from '../../../models/MapDataSource';
import { FormControlLabel, Paper, PaperProps, Switch } from '@material-ui/core';
import { theme } from '../../../../basf-ui';
import { checkEU28 } from '../geo/utils/checkEU28';

export interface ControlEU28Props {
  onChange?: (changed: boolean) => void;
}

const StyledPaper = styled(Paper)(props => ({
  padding: theme(props).spacing(2.375),
  backgroundColor: props['disabled'] ? '#dcdcdc' : undefined,
})) as React.FC<{ disabled: boolean } & PaperProps>;

const StyledControl = styled(FormControlLabel)(props => ({

  '& .label': {
    fontSize: '12px',
    color: '#606060',
  }
}));

export const ControlEU28 = React.memo((props: ControlEU28Props) => {
  const { onChange } = props;
  const { disabled, checked, loading, setChecked } = useControlEU28();

  React.useEffect(() => {
    if (checked && disabled && !loading) {
      setChecked(false);
      onChange?.(false);
    }
  }, [disabled, checked, loading]);

  const handler = React.useCallback((e) => {
    if (!disabled) {
      const value = e.target.checked;
      setChecked(value);
      onChange?.(value);
    }
  }, [onChange, disabled]);
  return <StyledPaper disabled={disabled} elevation={2}>
    <StyledControl disabled={disabled} classes={{ label: 'label' }}
      control={<Switch size="small" color="primary" checked={checked} onChange={handler} />}
      label="Show European Union"
    />
  </StyledPaper>;
});

function useControlEU28() {
  const [checked, setChecked] = React.useState(false);
  const { selectedCountry, loadingCountryDimension: loading } = useMapCountryDimension();
  const store = useMapStore();
  const dataSourceId = useHookSubscribe(MapDataSourceId.Default, store.dataSourceId$);

  const disabled = React.useMemo(() => {
    const isUNComtrade = dataSourceId === MapDataSourceId.UNComtrade;
    if (!loading && isUNComtrade) {
      const selectedEU28 = checkEU28(selectedCountry?.data.getValue<string>('code')!);
      return selectedEU28;
    }
    return loading;
  }, [selectedCountry, loading, dataSourceId]);
  return { disabled, checked, loading, setChecked };
}